import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { DashboardGrid } from "../components";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getData } from "../utils/apiFunctions";
import { useStateContext } from "../contexts/ContextProvider";
import { ApiEndpoints, LocationPaths } from "../utils/common";

const Dashboard = () => {
  const queryClient = useQueryClient();
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ["fetchDashboardData"],
    queryFn: () => getData(`${ApiEndpoints.DASHBOARD_DATA}`),
  });

  const { setLocation } = useStateContext();
  const locationData = useLocation();

  useEffect(() => {
    if (
      locationData.pathname === LocationPaths.DASHBOARD ||
      locationData.pathname === LocationPaths.ROOT
    ) {
      setLocation("Bitdefender / General / Dashboard");
    }

    return () => {
      queryClient.invalidateQueries();
    };
  }, [data]);

  return (
    <>
      <div className="ml-8">
        <gz-title fontSize="20" fontWeight="500" style={{ opacity: "0.7" }}>
          Dashboard
        </gz-title>
      </div>
      {isLoading && <gz-dashboard-loading-screen />}
      {isSuccess && (
        <div className="ml-4 mt-10 mr-6">
          <DashboardGrid queryResult={data} />
        </div>
      )}
    </>
  );
};

export default Dashboard;
